import * as React from 'react';
import { IFlippViewProps } from './flipp';
import classnames from 'classnames';
import Msdyn365 from '@msdyn365-commerce/core';

export default ({ config, context, id }: IFlippViewProps) => {
    const { merchantId, accessToken, merchantNameIdentifier, className } = config;
    const divRef = React.useRef<HTMLDivElement>(null);
    const [initialized, setInitialized] = React.useState(false);

    React.useEffect(() => {
        const div = divRef.current;
        if (!initialized && Msdyn365.isBrowser && div) {
            setInitialized(true);

            const childDiv = document.createElement('div');
            childDiv.id = `flipp-container-${id}`;
            div.appendChild(childDiv);

            const flippScript = `
            function initFlipp() {
                var flippContainer = document.querySelector("#flipp-container-${id}");
                var storefront = new Flipp.Storefront({
                    accessToken: "${accessToken}",
                    merchantId: "${merchantId}",
                    merchantNameIdentifier: "${merchantNameIdentifier}",
                    locale: "${context.request.locale || 'en-CA'}"
                });
                storefront.renderStorefront(flippContainer);
            };
            `.replace(/\s+/g, ' ');

            let script = document.createElement('script');
            script.innerHTML = flippScript;
            div.appendChild(script);

            script = document.createElement('script');
            script.src = `https://aq.flippenterprise.net/${merchantId}/iframe.js`;
            script.id = 'flipp-storefront-script';
            script.onload = () => {
                const win = window as any;
                if (win.initFlipp) {
                    win.initFlipp();
                }
            };
            div.appendChild(script);
        }
    }, [initialized, merchantId, accessToken, merchantNameIdentifier, divRef]);

    return (
        <div className={classnames('hei-flipp-container', className)}>
            <div ref={divRef} />
        </div>
    );
};
